import { createFileRoute } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { adminGetPost } from "@/lib/blog-admin.functions";
import { PostEditor } from "@/components/admin/PostEditor";
import { BlogSubNav } from "@/components/admin/BlogSubNav";

export const Route = createFileRoute("/admin/posts/$id")({
  component: EditPost,
  head: () => ({ meta: [{ title: "Edit post · Admin" }, { name: "robots", content: "noindex" }] }),
});

function EditPost() {
  const { id } = Route.useParams();
  const fetchPost = useServerFn(adminGetPost);
  const q = useQuery({ queryKey: ["admin-post", id], queryFn: () => fetchPost({ data: { id } }) });

  return (
    <div>
      <BlogSubNav />
      {q.isLoading ? (
        <p className="text-sm text-muted-foreground">Loading…</p>
      ) : q.error ? (
        <p className="text-sm text-destructive">Couldn't load post.</p>
      ) : q.data ? (
        <PostEditor initial={q.data as any} />
      ) : null}
    </div>
  );
}
